<template>

  <div>

    <table>
      <thead>
      <tr>
        <td>
          <div class="header-space">&nbsp;</div>
        </td>
      </tr>
      </thead>

      <tbody>
      <tr>
        <td>
          <b-row class="mt-3 p-0 col-12">
            <b-col cols="11" offset="1" class="row form-font">
        <td class="policy-number-background  col-4" style="height:55px">
          <div class="mt-3 fontsize">
            {{ $t('policynumber') }}
          </div>
        </td>
        <td class=" col-8 header_text text-center border-value font-weight-bolder" style="height:55px">
          <div class="mt-3 fontsize">
            {{ data1.policyInfo[0].POLICYPRODUCT }}
          </div>

        </td>

        <th class="title-box text-center mt-1 col-12">
          <div class="row">
            <div class="col-4"></div>
            <div class="col-8 nino-mtavruli fontsize"> {{ $t('Insurer') }}</div>
          </div>
        </th>

        <td class=" col-4 description-box ">
          <div class="">{{ $t('companyname') }}</div>
          <div class="">{{ $t('taxnumber') }}</div>
        </td>
        <td class=" col-8  text-center border-value p-0">
          <div class="short_fields">{{ data1.policyInfo[0].COMPNAME }}</div>
          <div class="short_fields">{{ data1.policyInfo[0].COMPSOCCART }}</div>
        </td>

        <th class="title-box text-center mt-1 col-12">
          <div class="row">
            <div class="col-4"></div>
            <div class="col-8 nino-mtavruli fontsize"> {{ $t('policyholder') }}</div>
          </div>
        </th>
        <td class=" col-4 description-box ">
          <div>
            <div>{{ $t('namesurname') }}</div>
            <div>{{ $t('pnumber') }}</div>
            <div>{{ $t('mob') }}</div>
          </div>
        </td>

        <td class=" col-8 text-center border-value p-0 ">
          <div class="short_fields">{{ data1.policyInfo[0].CUSTOMERNAME }}</div>
          <template v-if="data1.policyInfo[0].CUSTOMERSOCCARD ===''">
            <div class="short_fields" style="color:white">{{ empty }}</div>
          </template>
          <template v-else>
            <div class="short_fields"> {{ data1.policyInfo[0].CUSTOMERSOCCARD }}</div>
          </template>

          <div class="short_fields"> {{ data1.policyInfo[0].CUSTOMERPHONENUMBER }}</div>
        </td>


        <th class="title-box text-center mt-1 col-12">
          <div class="row">
            <div class="col-4"></div>
            <div class="col-8 nino-mtavruli"> {{ $t('beneficiarymhl') }}</div>
          </div>
        </th>
        <td class=" col-4 description-box ">
          <div>
            <div>{{ $t('namesurname') }}</div>
            <div>{{ $t('pnumber') }}</div>
            <div>{{ $t('mob') }}</div>
          </div>
        </td>

        <td class=" col-8 text-center border-value p-0 ">
          <div class="short_fields">{{ data1.policyInfo[0].BENEFICIARYNAME }}</div>
          <template v-if="data1.policyInfo[0].BENEFICIARYSOCCARD ===''">
            <div class="short_fields" style="color:white">{{ empty }}</div>
          </template>
          <template v-else>
            <div class="short_fields"> {{ data1.policyInfo[0].BENEFICIARYSOCCARD }}</div>
          </template>
          <div class="short_fields"> {{ data1.policyInfo[0].BENEFICIARYPHONENUMBER }}</div>
        </td>

        <th class="title-box text-center mt-1 col-12">
          <div class="row">
            <div class="col-4"></div>
            <div class="col-8 nino-mtavruli"> {{ $t('vehicleinformation') }}</div>
          </div>
        </th>
        <td class=" col-4 description-box ">

          <div>{{ $t('automodel') }}</div>
          <div>{{ $t('vincode') }}</div>
          <div>{{ $t('year') }}</div>
          <div>{{ $t('regnumber') }}</div>
        </td>

        <td class=" col-8 text-center border-value p-0 ">
          <div class="short_fields">{{ data1.policyInfo[0].CARMARKVALUE }}</div>
          <div class="short_fields"> {{ data1.policyInfo[0].VINCODE }}</div>
          <div class="short_fields">{{ data1.policyInfo[0].PRODUCTIONDATE }}</div>
          <div class="short_fields"> {{ data1.policyInfo[0].PLATENUMBER1 }}</div>
        </td>

        <th class="title-box text-center mt-1 col-12" >
          <div class="row">
            <div class="col-4"></div>
            <div class="col-8 nino-mtavruli"> {{ data1.tpl_ma_Risks[0].risk }}</div>
          </div>
        </th>

        <td class="col-4 description-box" >
          <div style="font-size: 10pt;">{{ $t('suminsured') }}</div>
        </td>
        <td class="col-8 text-center border-value p-0" >
          <div class="short_fields" style="font-size: 10pt;">{{ data1.tpl_ma_Risks[0].amount }}</div>
        </td>
        </b-col>
        </b-row>
        <b-row class="p-0 col-12">
          <b-col cols="11" offset="1" class="row form-font">
            <td class="col-12 pl-1 border-0 description-box mt-1" v-if="data1.policyInfo[0].ADDNOTE">
              <div class="nino-mtavruli">{{ $t('additionalinformation') }}</div>
            </td>
            <td class=" col-12  border-value p-0 " v-if="data1.policyInfo[0].ADDNOTE">
              <div class=" p-1">
                {{ data1.policyInfo[0].ADDNOTE }}
              </div>
            </td>

            <td class="col-12 pl-1 border-0 description-box mt-1 "
                v-if="data1.policyInfo[0].DRIVERRULES ||data1.policyInfo[0].OWNNAME">
              <div class="nino-mtavruli" style="font-weight:bold;">{{ $t('authorizeddriver') }}</div>
            </td>
            <td class="col-12  border-value p-0 " v-if="data1.policyInfo[0].DRIVERRULES">
              <div class=" p-1">
                {{ data1.policyInfo[0].DRIVERRULES }}
              </div>
            </td>
            <td class="col-12 pl-1  border-value p-0 " v-if="data1.policyInfo[0].OWNNAME">
<!--              <div class=" border-top-0 ">
                {{ data1.policyInfo[0].OWNNAME }}
              </div>-->
            </td>
            <td class="col-12 pl-1 border-0 description-box mt-1">
              <div class="nino-mtavruli" style="font-weight:bold;">{{ $t('insurancearea') }}</div>
            </td>
            <td class=" col-12  border-value p-0 " v-if="data1.policyInfo[0].COUNTRYS">
              <div class="p-1">
                {{ data1.policyInfo[0].COUNTRYS }}
              </div>
            </td>
          </b-col>
        </b-row>
        <b-row class="p-0 col-12">
          <b-col cols="11" offset="1" class="row form-font">
            <td class="col-6 pl-1 border-0 description-box mt-1  nino-mtavruli">
              <div class="nino-mtavruli" style="font-weight:bold;">{{ $t('yearpremium') }}</div>
            </td>
            <td class="col-6 pl-1 description-box border-bottom-0 border-top-0 border-right-0 mt-1 nino-mtavruli">
              <div class="nino-mtavruli">{{ $t('paymentcount') }}</div>
            </td>
            <td class="col-6 pl-1 border-value ">
              {{ data1.policyInfo[0].INSURANCEPREMIUMS }}
            </td>

            <td class="col-6 pl-1 border-value ">
              {{ data1.policyInfo[0].PAYMENTCOUNT }}
            </td>
            <td class="col-12 pl-1 border-0 description-box mt-1 nino-mtavruli" style="font-weight:bold;">
              {{ $t('paymentschedule') }}
            </td>

            <div class="col-12 mt-1 m-0 d-flex justify-content-between payment">
              <div class="payment-block row p-0  " v-if="data1.payment.length>=2">
                <div class="col-6 pl-1 border-value payment-title nino-mtavruli">
                  {{ $t('date') }}
                </div>
                <div class="col-6 pl-1 border-value payment-title nino-mtavruli">
                  {{ $t('amount') }}
                </div>
                <template v-for="(payment,j) in data1.payment.slice(0, Math.round( data1.payment.length/2))"  >
                  <!--//.slice(0, data.payment.length/2)">-->
                 
                  <td  class="col-6 pl-1">
                    {{ payment.PAYDATE }}
                  </td>
                  <td  class="col-6 pl-1">
                    {{ payment.PAYAMAUNT }}
                  </td>
                 
                </template>
              </div>

              <div class="payment-block row p-0 " v-if="data1.payment.length>=2">
                <div class="col-6 pl-1 border-value payment-title nino-mtavruli">
                  {{ $t('date') }}
                </div>
                <div class="col-6 pl-1 border-value payment-title nino-mtavruli">
                  {{ $t('amount') }}
                </div>


                <template
                    v-for="(payment,index) in data1.payment.slice(Math.round(data1.payment.length/2), data1.payment.length)">
                  <!--//.slice(0, data.payment.length/2)">-->

                  <td  class="col-6 pl-1">
                    {{ payment.PAYDATE }}
                  </td>
                  <td  class="col-6 pl-1">
                    {{ payment.PAYAMAUNT }}
                  </td>
                </template>
              </div>

            </div>
          </b-col>
        </b-row>
        <b-row class="mt-3 p-0 col-12">
          <b-col cols="11" offset="1" class="row form-font">
            <div class="col-12 mt-1">
              <div class="row" v-if="data1.payment.length<2">
                <template v-for="(payment,i) in data1.payment">
                  <!--//.slice(0, data.payment.length/2)">-->
                  <div  class="col-2 pl-1 payment-title nino-mtavruli">
                    {{ $t('date') }}
                  </div>
                  <div  class="col-4 pl-1">
                    {{ payment.PAYDATE }}
                  </div>
                  <div  class="col-2 pl-1 payment-title nino-mtavruli">
                    {{ $t('amount') }}
                  </div>
                  <div class="col-4 pl-1">
                    {{ payment.PAYAMAUNT }}
                  </div>
                </template>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="p-0 col-12">
          <b-col cols="11" offset="1" class="row form-font">
            <td class="col-12 pl-1 border-0 description-box mt-1 nino-mtavruli" style="font-weight:bold;">
              {{ $t('coverfrom') }}
            </td>

            <td class="col-12 border-0">
              <div class="row  border-value">

                <div class="col-2 pl-1 payment-title border-0 " style="font-size:10pt">
                  {{ $t('from') }}
                </div>
                <div class="col-4" style="font-size:10pt">
                  {{ data1.policyInfo[0].FROMDATE }}
                </div>
                <div class="col-2 pl-1 payment-title border-0 " style="font-size:10pt">
                  {{ $t('including') }}
                </div>
                <div class="col-4" style="font-size:10pt">
                  {{ data1.policyInfo[0].TODATE }}
                </div>

              </div>
            </td>
          </b-col>
        </b-row>
        <b-row class="p-0 col-12">
          <b-col cols="11" offset="1" class="row form-font">
            <td class="col-12 description-box mt-1 text-center">
              {{ $t('mhlnots') }} <a :href="$t('tpllink')" target="_blank"
                                     class="conditions">{{ $t('tpllink') }}</a>
            </td>

            <signature class="col-12 mt-2"/>
          </b-col>
        </b-row>
        </td>
      </tr>
      </tbody>

      <tfoot>
      <tr>
        <td>
          <div class="footer-space">&nbsp;</div>
        </td>
      </tr>
      </tfoot>
    </table>
    <div class="page-header">
      <b-col cols="12" class=" row p-0 mt-3 header11">
        <b-col cols="12 d-flex pb-4">
          <div class="header header_logo col-2 p-0 "></div>
          <div class=" header header_text col-10 p-0 d-flex">
            <h5 class="ml-md-5 nino-mtavruli font-weight-bold mt-3" style="color: #007960; font-size:23px !important">
              {{ $t('tplslogan') }}</h5>
          </div>
        </b-col>
      </b-col>
    </div>
    <div class="page-footer">
      <b-row class="m-0 mt-3 footer col-12 pl-0">
        <b-col cols="11" offset="1" class="pl-0 mt-2 ">
          <div class="d-flex justify-content-between mr-4 pt-4 pb-4">

            <template v-if="$t('isgeo') == 1">
              <img src="../assets/img/ardi-logo.svg" width="110">
            </template>
            <template v-else>
              <img src="../assets/img/logoEn1.svg" width="110">
            </template>
            <div class="footer-slogan align-content-center" style="color: #007960; font-size: 20px;">
              {{ $t('footerslogan') }}
            </div>
          </div>
        </b-col>

      </b-row>
    </div>

  </div>

</template>

<script>
//import InsuredRisks from "./InsuredRisks";
import Signature from "@/Auto/components/Signature";

export default {
  name: "Contract",
  components: {
    //'insured-risks': InsuredRisks,
    Signature
  },
  data() {
    return {
      empty: "0",
      data1: {},
      id: this.$route.params.id,
      cust: this.$route.params.cust,
    }
  },
  mounted() {
    this.init();
    
  },
  methods:{
    init(){
      this.$http.get(`/policy/GetPolicyInfoTpl/${this.id}/${this.cust}`).then((r) => {
      
        this.data1 = r.data;
      
      }).catch((e) => {
        console.log(e)
      })
    }
  }
}
</script>

<style scoped>
@import "~bpg-nino-mtavruli";

.nino-mtavruli {
  font-family: "BPG Nino Mtavruli", sans-serif;
  font-size: 16px;
}


.header11, .header-space,
.footer-space {
  height: 100px;
}

.header11 {
  position: fixed;
  top: 0;
}

.fontsize {
  font-size: 16px
}

@media print {
  div {
    break-inside: avoid !important;
  }

  td {
    break-inside: avoid !important;
  }


  .footer {
    break-inside: avoid !important;
    page-break-after: always;
    page-break-before: always;
  }
}

.page-footer {
  position: absolute;
  bottom: 5px;
}

.page-header {
  position: absolute;
  top: 5px;
}

.footer {
  position: fixed;
  bottom: 0;
}


h5 {
  font-size: 15pt;
  color: #007960;
}

.company {
  font-size: 17pt;
}

.watermark {
  background: url("../assets/logo.png") center center no-repeat;
  background-size: 100px;
}

.blur {
  background-color: rgba(255, 255, 255, 0.50);
}

.slogan {
  color: #14836D;
  text-transform: uppercase !important;
  -webkit-font-feature-settings: 'case' on !important;
  font-feature-settings: 'case' on !important;
}

.header {
  height: 60px;
}

.header_logo {
  background: url("../assets/img/header.svg") no-repeat center;
  background-size: cover;
  width: 107px;
}

.risk-header-1 {
  font-size: 12pt !important;
}

.risk-header-2 {
  font-size: 11pt !important;
}

.risk-header-3 {
  font-size: 11pt !important;
  padding: 5px;
}

.risk-header-4 {
  font-size: 10pt !important;
}

.risk-header-5 {
  font-size: 10pt !important;
  padding: 5px 6px;
}

.header_text {
  background: #D9D8D6;
}

.payment-block {
  width: 51%;
}

.title-box {
  background: #005745;
  color: #fafafa;
}

.conditions {
  color: #ffffff;
  font-size: 11pt;
}

.risk-header-3 {
}

.form-box {
  background: #005745;
}

.description-box {
  background: #007960;
  color: #ffffff;
}

.right-border {
  border-right: 1px solid #EEEEEE;
}

.sub_risk_text_color {
  color: #00A887;
}

.form-font {
  font-size: 10pt;
}

.border-value {
  border: 1px solid #D9D8D6;
}

.payment td {
  /*width: 25%;*/
  border: 1px solid #EEEEEE;
}

.p-l-t-1 {
  padding-top: 1px;
  padding-left: 1px;
}

.payment div {
  font-size: 12pt;
}

.green-border-2 {
  border: 2px solid #00A886;
}

.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.h-center {
  transform: translateX(29%);
}

.short_fields:nth-child(n) {
  border-bottom: 1px solid #D9D8D6;
}

/*#print-header {
  padding: 15px 0;
  display: table-header-group;
}

#print-footer {
  display: table-footer-group;
  padding-bottom: 15px;
}*/

/*.print-body{
  margin-bottom: 5rem;
}*/

table {
  width: 100%;
}

/*
.no-break{
  page-break-inside: avoid;
}
*/

#insured-risk > thead.border-bottom-0 {
  border-bottom: 1px solid #007960 !important;
}

.policy-number-background {
  background-color: #00a987;
  color: #fff;
  font-size: 11pt;
}

th, .green-border {
  border: 1px solid #00A886;
  border-collapse: collapse;
  font-size: 10pt;
}

.green-outline {
  /*outline: 1px solid #00A886;*/
}


/*table#insured-risk, table#extra-risk {
  outline: 1px solid #00A886;
}*/
.border-bottom {
  border-bottom: 1px solid #007960 !important;
}


table#insured-risk td, table#extra-risk td {
  /*font-size: 8.3pt !important;*/
  border: 1px solid #EEEEEE;
}

/*#extra-risk>tbody>tr>td{
  border-top:0 !important;*/
/*border-left: 0 !important;*/
/*page-break-inside: avoid;
  page-break-after: auto
}*/
#extra-risk > tbody > tr > td:nth-child(1) {
  padding-top: 2px !important;
}

/*table {
  page-break-after: auto
}

tr ,td{
  page-break-inside: avoid;
  page-break-after: auto
}

@media print {

  table {
    page-break-after: auto
  }

  tr {
    page-break-inside: avoid;
    page-break-after: auto
  }

  td {
    page-break-inside: avoid;
    page-break-after: auto
  }
}*/
</style> 